import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';

export default function TestWelcomeEmail() {
  const [sending, setSending] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const sendWelcomeEmail = async () => {
    if (!firstName || !email) {
      toast({
        title: "Error",
        description: "Por favor ingresa nombre y email",
        variant: "destructive",
      });
      return;
    }

    setSending(true);
    try {
      const { data, error } = await supabase.functions.invoke('send-welcome-email', {
        body: { firstName, email }
      });
      
      if (error) {
        throw error;
      }

      console.log('Email sent:', data);
      toast({
        title: "¡Email enviado exitosamente!",
        description: `Email de bienvenida enviado a ${email}`,
      });
      
      // Clear form
      setFirstName('');
      setEmail('');
    } catch (error: any) {
      console.error('Send email error:', error);
      toast({
        title: "Error al enviar email",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="container mx-auto p-8 max-w-md">
      <h1 className="text-2xl font-bold mb-6">Test Welcome Email</h1>
      <div className="space-y-4">
        <div>
          <Label htmlFor="firstName">Nombre</Label>
          <Input
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Ingresa el nombre"
          />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Ingresa el email"
          />
        </div>
        <Button 
          onClick={sendWelcomeEmail} 
          disabled={sending}
          className="w-full"
        >
          {sending ? 'Enviando...' : 'Enviar Email de Bienvenida'}
        </Button>
      </div>
    </div>
  );
}